"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
    "use strict";

    //GalleryCtrl.$inject = ['GalleryService', '$scope', '$window', 'params'];

    angular.module("gallery").controller("GalleryCtrl", GalleryCtrl);

    function GalleryCtrl(GalleryService, CustomListsService, $scope, $window, $timeout, params) {
        var _this = this;

        var vm = this;

        console.log("params", params);

        vm.load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            if (params.isRestricted == false) {
                                vm.isRestricted = params.isRestricted;
                            }

                            vm.docs = [];

                            if (!params.type) {
                                _context.next = 9;
                                break;
                            }

                            vm.nameOfTheList = "typeDoc" + params.type.charAt(0).toUpperCase() + params.type.slice(1);
                            _context.next = 6;
                            return CustomListsService.getSelectArray(vm.nameOfTheList);

                        case 6:
                            vm.typesDoc = _context.sent;
                            _context.next = 10;
                            break;

                        case 9:
                            vm.typesDoc = GalleryService.getDefaultTypesDoc;

                        case 10:

                            $timeout(function () {

                                if (params) {
                                    if (params.docs) {
                                        vm.initDocs = [].concat(_toConsumableArray(params.docs)); // copy
                                        vm.docs = params.docs;
                                    }

                                    if (params.title) {
                                        vm.title = params.title;
                                    }
                                }
                            }, 100);

                        case 11:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        vm.load();

        vm.delete = function (index) {
            console.log("index", index);

            if (Array.isArray(vm.docs)) {
                vm.docs.splice(index, 1);
            } else {
                vm.docs = {};
            }
        };

        vm.isArray = function () {
            return vm.docs ? Array.isArray(vm.docs) : false;
        };

        vm.cancel = function () {
            $scope.$close(vm.initDocs);
        };

        vm.return = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _doc, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, doc;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            // Check type:
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 3;
                            _iterator = vm.docs[Symbol.iterator]();

                        case 5:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context2.next = 13;
                                break;
                            }

                            _doc = _step.value;

                            if (!(!_doc.what || !_doc.what.value)) {
                                _context2.next = 10;
                                break;
                            }

                            Notiflix.Notify.failure("Veuillez sélectionner un type de document pour chaque document.");
                            return _context2.abrupt("return");

                        case 10:
                            _iteratorNormalCompletion = true;
                            _context2.next = 5;
                            break;

                        case 13:
                            _context2.next = 19;
                            break;

                        case 15:
                            _context2.prev = 15;
                            _context2.t0 = _context2["catch"](3);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                        case 19:
                            _context2.prev = 19;
                            _context2.prev = 20;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 22:
                            _context2.prev = 22;

                            if (!_didIteratorError) {
                                _context2.next = 25;
                                break;
                            }

                            throw _iteratorError;

                        case 25:
                            return _context2.finish(22);

                        case 26:
                            return _context2.finish(19);

                        case 27:
                            if (!params.fromModal) {
                                _context2.next = 59;
                                break;
                            }

                            console.log("close modal");

                            if (!vm.nameOfTheList) {
                                _context2.next = 58;
                                break;
                            }

                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context2.prev = 33;
                            _iterator2 = vm.docs[Symbol.iterator]();

                        case 35:
                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                _context2.next = 44;
                                break;
                            }

                            doc = _step2.value;
                            _context2.next = 39;
                            return CustomListsService.getNameByValue(vm.nameOfTheList, doc.what.value);

                        case 39:
                            doc.what.name = _context2.sent;


                            doc.what.list = vm.nameOfTheList;

                        case 41:
                            _iteratorNormalCompletion2 = true;
                            _context2.next = 35;
                            break;

                        case 44:
                            _context2.next = 50;
                            break;

                        case 46:
                            _context2.prev = 46;
                            _context2.t1 = _context2["catch"](33);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context2.t1;

                        case 50:
                            _context2.prev = 50;
                            _context2.prev = 51;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 53:
                            _context2.prev = 53;

                            if (!_didIteratorError2) {
                                _context2.next = 56;
                                break;
                            }

                            throw _iteratorError2;

                        case 56:
                            return _context2.finish(53);

                        case 57:
                            return _context2.finish(50);

                        case 58:

                            $scope.$close(vm.docs);

                        case 59:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[3, 15, 19, 27], [20,, 22, 26], [33, 46, 50, 58], [51,, 53, 57]]);
        }));

        vm.redirect = function (url) {
            $window.open(url, "_blank");
        };
    }
})();